import { render, staticRenderFns } from "./TabJson.vue?vue&type=template&id=56a0cfb7&scoped=true"
import script from "./TabJson.vue?vue&type=script&lang=js"
export * from "./TabJson.vue?vue&type=script&lang=js"
import style0 from "./TabJson.vue?vue&type=style&index=0&id=56a0cfb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a0cfb7",
  null
  
)

export default component.exports